import ContactoHeroSection from "../../components/ui/ContactoHeroSection"

const ContactoScreen = () => {
  return (
    <>
      <ContactoHeroSection />
      <div style={{ maxWidth: 600, margin: '40px auto', padding: 24, borderRadius: 8, boxShadow: '0 2px 8px rgba(0,0,0,0.1)', background: '#fff' }}>
        <h4 className="text-center">¿Tienes alguna pregunta o deseas reservar una cita?</h4>
        {/* <form>
          <div style={{ marginBottom: 16 }}>
          <label htmlFor="nombre">Nombre:</label><br />
          <input type="text" id="nombre" name="nombre" style={{ width: '100%', padding: 8 }} />
        </div>
        <div style={{ marginBottom: 16 }}>
          <label htmlFor="email">Correo electrónico:</label><br />
          <input type="email" id="email" name="email" style={{ width: '100%', padding: 8 }} />
        </div>
        <div style={{ marginBottom: 16 }}>
          <label htmlFor="mensaje">Mensaje:</label><br />
          <textarea id="mensaje" name="mensaje" rows="4" style={{ width: '100%', padding: 8 }} />
        </div>
        <button type="submit" style={{ padding: '10px 24px', background: '#1976d2', color: '#fff', border: 'none', borderRadius: 4 }}>Enviar</button>
      </form> */}
        <hr style={{ margin: '32px 0', border: 'none', borderTop: '1px solid #222' }} />
        <div style={{ marginTop: 32 }}>
          <p><strong>Teléfono: </strong>621 06 10 16</p>
          <p><strong>Instagram: </strong> <a href="https://www.instagram.com/manusfortis/" target="_blank" rel="noopener noreferrer">@manusfortis</a></p>
          <p><strong>Correo:</strong> contacto@manusfortis.es</p>
          <p><strong>Dirección:</strong> Calle Asarau 20, 1º B - 12001 Castellón de la Plana</p>
        </div>
      </div>
    </>
  )
}
export default ContactoScreen